import script from "./MyAccountView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyAccountView.vue?vue&type=script&setup=true&lang=ts"

import "./MyAccountView.vue?vue&type=style&index=0&id=57d3841c&lang=css"

const __exports__ = script;

export default __exports__